"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.BathOutlineSVG = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _react = _interopRequireDefault(require("react"));
var _Icon = require("../Icon");
var _excluded = ["children"];
var innerSvg = '<path d="M27 19v3.76A3.24 3.24 0 0123.76 26H8.24A3.24 3.24 0 015 22.76V19zM5 17a2 2 0 00-2 2v3.76A5.26 5.26 0 008.24 28h15.52A5.26 5.26 0 0029 22.76V19a2 2 0 00-2-2z"/><path d="M22 27v2a1 1 0 002 0v-2zM8 27v2a1 1 0 002 0v-2z"/><path d="M19.05 2a4.47 4.47 0 00-5 4.09 4 4 0 00-3 3.29.51.51 0 00.5.59h6.92a.51.51 0 00.5-.59 4 4 0 00-2.88-3.24A2.41 2.41 0 0118.45 4 2.61 2.61 0 0121 6.63V17h2V6.69A4.64 4.64 0 0019.05 2z"/>';
var BathOutlineSVG = function BathOutlineSVG(_ref) {
  var children = _ref.children,
    rest = (0, _objectWithoutProperties2.default)(_ref, _excluded);
  return /*#__PURE__*/_react.default.createElement("svg", (0, _extends2.default)({
    viewBox: "0 0 32 32"
  }, rest), children, /*#__PURE__*/_react.default.createElement("g", {
    stroke: "none",
    dangerouslySetInnerHTML: {
      __html: innerSvg
    }
  }));
};
exports.BathOutlineSVG = BathOutlineSVG;
BathOutlineSVG.propTypes = process.env.NODE_ENV !== "production" ? {
  children: _propTypes.default.node
} : {};
var _default = (0, _Icon.withIcon)(BathOutlineSVG);
exports.default = _default;